module.exports = __webpack_public_path__ + "img/login-free-ecshopx.de4c5dc0.jpg";